module.exports = __webpack_public_path__ + "img/Poser.42029b69.jpg";